var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "52px",
    viewBox: "0 0 52 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 29") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GFL-Marketing",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GFL---Landing-Page",
    transform: "translate(-1526, -7396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(-0, 7227)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-29",
    transform: "translate(1527, 170)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-9",
    stroke: "#C6A566",
    strokeWidth: 2,
    fill: "#1A1A1A",
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("g", {
    id: "instagram",
    transform: "translate(14, 13)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5,18 C15.0898417,18 18,15.0898417 18,11.5 C18,7.9101475 15.0898417,5 11.5,5 C7.9101475,5 5,7.9101475 5,11.5 C5,15.0898417 7.9101475,18 11.5,18 Z M11.5,15.8333333 C13.8931917,15.8333333 15.8333333,13.8931917 15.8333333,11.5 C15.8333333,9.106765 13.8931917,7.16666667 11.5,7.16666667 C9.106765,7.16666667 7.16666667,9.106765 7.16666667,11.5 C7.16666667,13.8931917 9.106765,15.8333333 11.5,15.8333333 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,4 C17.4477,4 17,4.44772 17,5 C17,5.55228 17.4477,6 18,6 C18.5523,6 19,5.55228 19,5 C19,4.44772 18.5523,4 18,4 Z",
    id: "Path",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.683685455,3.42497182 C0,4.76678136 0,6.52331227 0,10.0363636 L0,12.9636364 C0,16.4766773 0,18.23325 0.683685455,19.5749864 C1.28507273,20.7553045 2.24467455,21.7149273 3.42497182,22.3162727 C4.76678136,23 6.52331227,23 10.0363636,23 L12.9636364,23 C16.4766773,23 18.23325,23 19.5749864,22.3162727 C20.7553045,21.7149273 21.7149273,20.7553045 22.3162727,19.5749864 C23,18.23325 23,16.4766773 23,12.9636364 L23,10.0363636 C23,6.52331227 23,4.76678136 22.3162727,3.42497182 C21.7149273,2.24467455 20.7553045,1.28507273 19.5749864,0.683685455 C18.23325,0 16.4766773,0 12.9636364,0 L10.0363636,0 C6.52331227,0 4.76678136,0 3.42497182,0.683685455 C2.24467455,1.28507273 1.28507273,2.24467455 0.683685455,3.42497182 Z M12.9636364,2.09090909 L10.0363636,2.09090909 C8.24533273,2.09090909 7.02780682,2.09254 6.08672,2.16942273 C5.17002364,2.24431909 4.70124182,2.38007136 4.37422364,2.54669591 C3.58736227,2.94762773 2.94762773,3.58736227 2.54669591,4.37422364 C2.38007136,4.70124182 2.24431909,5.17002364 2.16942273,6.08672 C2.09254,7.02780682 2.09090909,8.24533273 2.09090909,10.0363636 L2.09090909,12.9636364 C2.09090909,14.7547091 2.09254,15.9721409 2.16942273,16.9132591 C2.24431909,17.8300182 2.38007136,18.2988 2.54669591,18.6258182 C2.94762773,19.4126273 3.58736227,20.0523409 4.37422364,20.4532727 C4.70124182,20.6199182 5.17002364,20.7557227 6.08672,20.8305773 C7.02780682,20.9074182 8.24533273,20.9090909 10.0363636,20.9090909 L12.9636364,20.9090909 C14.7547091,20.9090909 15.9721409,20.9074182 16.9132591,20.8305773 C17.8300182,20.7557227 18.2988,20.6199182 18.6258182,20.4532727 C19.4126273,20.0523409 20.0523409,19.4126273 20.4532727,18.6258182 C20.6199182,18.2988 20.7557227,17.8300182 20.8305773,16.9132591 C20.9074182,15.9721409 20.9090909,14.7547091 20.9090909,12.9636364 L20.9090909,10.0363636 C20.9090909,8.24533273 20.9074182,7.02780682 20.8305773,6.08672 C20.7557227,5.17002364 20.6199182,4.70124182 20.4532727,4.37422364 C20.0523409,3.58736227 19.4126273,2.94762773 18.6258182,2.54669591 C18.2988,2.38007136 17.8300182,2.24431909 16.9132591,2.16942273 C15.9721409,2.09254 14.7547091,2.09090909 12.9636364,2.09090909 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.8bacb5a5a0aad91e4739028bddb0e19c.svg";
export { ForwardRef as ReactComponent };